import React, { useState, useEffect } from "react";
import { Select, MenuItem, Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import { useLanguageContext } from "../../../Context/LanguageContext";
import {
  useSelectedFilterActionsContext,
  useItemSelectedFilterActionsContext,
  useSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import { changeoPerator2Mui } from "./HelperDashboard";
import { _helper } from "../../GlobalFunction/dateHelper";
import equipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import {
  useAMGSelectedContext,
  useMainGridSortContext,
} from "../../../Context/GlobalContext";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { toast } from "react-toastify";
export default function SaveUserFilter({
  saveFilterlist,
  reportCode,
  tableData,
  apiRef,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();
  const itemSelectedFilter = useSelectedFilterContext();
  const sortBy = useMainGridSortContext();
  const selectedAnlageG = useAMGSelectedContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();
  const [value, setValue] = useState("");

  const handleDelete = () => {
    setGlobalSpinner(true);
    GridColumn_SettingActions.deleteSavedFilter(value, reportCode);
    setValue((prev) => "");
  };

  const getEquipmentList = (isReset, _id) => {
    const sortOrder = sortBy.order === "" ? "asc" : sortBy.order;
    sessionStorage.getItem("eqGId");
    equipmentGroupActions.getEquipmentList2(
      reportCode,
      sortOrder,
      selectedAnlageG,
      parseInt(1),
      parseInt(tableData.pagination),
      sortBy.key,
      isReset ? null : _id ? _id : value,
      []
    );
  };

  const handleDropChange = (_id) => {
    setValue((prev) => _id);

    updateSelectedFilter(
      _id === "" && itemSelectedFilter !== ""
        ? ""
        : saveFilterlist.filter((filter) => filter.id === _id)
    );
    setGlobalSpinner(true);
    if (_id !== "") {
      GridColumn_SettingActions.getSaveFilterValue(_id, reportCode);
    } else {
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      getEquipmentList(true);
    }
  };

  useEffect(() => {
    if (itemSelectedFilter !== "") {
      setValue((prev) => itemSelectedFilter[0].id);
    }
  }, []);

  /**-----------------------------------------listner filter value on FilterID Start---------------------------------------*/
  useEffect(() => {
    function getSaveFilterValueSuccess() {
      var res = gridColSettingStore.getSavedFilterValueResult();
      if (res.length > 0) {
        const filterList = CreateFilterModel(
          res,
          reportCode,
          tableData.hearderType
        );
        updateListSelectedFilter(filterList);
        getEquipmentList(false);
      } else {
        updateListSelectedFilter([]);
      }
    }

    function getSaveFilterValueFailure() {
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_VALUE_SUCCESS,
      getSaveFilterValueSuccess
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_VALUE_FAILURE,
      getSaveFilterValueFailure
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_VALUE_SUCCESS,
        getSaveFilterValueSuccess
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_VALUE_FAILURE,
        getSaveFilterValueFailure
      );
    };
  }, [value]);

  /**-----------------------------------------listner filter value on FilterID End---------------------------------------*/

  /**-----------------------------------------listner  on Filter del Start---------------------------------------*/
  useEffect(() => {
    function getDelSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilDelResult();
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      toast.success(localization.delSuccess);
      GridColumn_SettingActions.getSaveFilterList(selectedAnlageG, reportCode);
      getEquipmentList(true);
      apiRef.current.hideFilterPanel();
    }

    function getDelSaveFilterResultFailure() {
      const res = gridColSettingStore.getsaveFilDelResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_SUCCESS,
      getDelSaveFilterResultSuccess
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER__FAILURE,
      getDelSaveFilterResultFailure
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_SUCCESS,
        getDelSaveFilterResultSuccess
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER__FAILURE,
        getDelSaveFilterResultFailure
      );
    };
  }, []);
  /**-----------------------------------------listner  on Filter del End---------------------------------------*/
  return (
    <>
      <Box id="saveFiltercont" display="flex" alignItems="center">
        <Select
          value={value}
          disabled={saveFilterlist.length === 0}
          onChange={(e) => handleDropChange(e.target.value)}
          displayEmpty
          sx={{
            height: 48, // Adjust Select height
            minWidth: 200,
            "& .MuiSelect-select": {
              height: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <MenuItem value="">{localization.filterPlaceholder}</MenuItem>
          {saveFilterlist.length > 0 &&
            saveFilterlist.map((item, index) => (
              <MenuItem value={item.id} key={index}>
                {item.title}
              </MenuItem>
            ))}
        </Select>
        <Button
          variant="outlined"
          disabled={value === ""}
          onClick={handleDelete}
          startIcon={<DeleteIcon color="error" />}
        />
      </Box>
    </>
  );
}

export function CreateFilterModel(itemSelectedFilter, reportCode, hearderType) {
  if (itemSelectedFilter.length > 0) {
    const _filterlist = itemSelectedFilter.map((item) => {
      const _operator = changeoPerator2Mui(
        item["Operator"],
        hearderType[item.Name],
        item.Name
      );
      let _value = item.Operator === "#" ? "empty" : item.Value;

      return {
        Name: item.Name,
        Operator: item.Operator,
        Value: _value,
        mapping: _operator,
      };
    });

    return _filterlist;
  } else {
    return [];
  }
}
